import {aShowDialog} from '@modifi/plugin-dialogs'
import {DIALOG_SHIPMENT_TRACKING_DETAILS} from '../constants'

export const aShowShipmentTrackingDetailsDialog = (externalShipmentId: string): any =>
  aShowDialog(DIALOG_SHIPMENT_TRACKING_DETAILS, {externalShipmentId})
